var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Locked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.2251 21.75V8.15H7.1751V6.20522C7.1751 4.86007 7.64385 3.71875 8.58135 2.78125C9.51885 1.84375 10.6584 1.375 12.0001 1.375C13.3418 1.375 14.4813 1.84375 15.4188 2.78125C16.3563 3.71875 16.8251 4.85956 16.8251 6.20367V8.14695H19.7751V21.75H4.2251ZM6.1001 19.875H17.9001V10.025H6.1001V19.875ZM9.0501 8.15H14.9501V6.19615C14.9501 5.38205 14.6636 4.6875 14.0905 4.1125C13.5175 3.5375 12.8217 3.25 12.003 3.25C11.1844 3.25 10.4876 3.53681 9.9126 4.11042C9.3376 4.68402 9.0501 5.38055 9.0501 6.2V8.15Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocked);
export default __webpack_public_path__ + "static/media/icon-locked.9ed7fd0520f2be3d8589421c55f3c6f8.svg";
export { ForwardRef as ReactComponent };